import { render, staticRenderFns } from "./FormattedHtml.vue?vue&type=template&id=b457fd08&scoped=true"
import script from "./FormattedHtml.vue?vue&type=script&lang=js"
export * from "./FormattedHtml.vue?vue&type=script&lang=js"
import style0 from "./FormattedHtml.vue?vue&type=style&index=0&id=b457fd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b457fd08",
  null
  
)

export default component.exports